<script>
import axios from "axios";

export default {
    name: 'Poll',

    data() {
        return {
			eventQueueUrl: "",
			serverPollDuration: 500,

			eventDispatchMap: {

				admissionFieldUpdate: "admissionFieldUpdateEvent",
				admissionUpdate: "admissionUpdateEvent",
				admissionDelete: "admissionDeleteEvent",

				listDelete: "listDeleteEvent",
				listUpdate: "listUpdateEvent",
				listPermissions: "listPermissionsEvent",
				sosListsUpdate: "sosListsUpdateEvent",
				userListsUpdate: "userListsUpdate",

				editingState: "editingStateEvent",

				rankChange: "rankChangeEvent",
				
			}
        }
    },
    methods: {
        initializePolling() {
            var temp = this;
            axios.post("/api/1/evqueues").then(function (response) {
				
                temp.eventQueueUrl = response.data.url;

                temp.serverPoll(); // start polling
            })
        },
        serverPoll() {
			var temp = this;

            axios.delete(this.eventQueueUrl, {
                timeout: 35000
            }).then(function (response) {
				
				var events = response.data.events;
				for(var i=0; i<events.length; i++){
					temp.$store.dispatch(temp.eventDispatchMap[events[i].key],events[i].val);
				}
            }).catch((error) => {
                // error
				if(error.response && error.response.status == 405){
					window.location = "/"
				}
            }).then(() => {
                setTimeout(temp.serverPoll, temp.serverPollDuration);
            })
        }
    }
}
</script>
